import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Tabs as MuiTabs, Tab } from '@material-ui/core';
import LabelWithBadge from './components/LabelWithBadge';

import useStyles from './useStyles';

const Tabs = props => {
  const {
    currentTabIndex,
    onChange,
    allTabsBadgeCount,
    waitlistTabsBadgeCount,
    favoriteTabsBadgeCount,
    tabIndexValues,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [first, second, third] = tabIndexValues;

  return (
    <div>
      <MuiTabs
        value={currentTabIndex}
        onChange={onChange}
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabs}
      >
        <Tab
          label={
            <LabelWithBadge label={t('components.LoanOfficerRealEstateAgents.Tabs.allTab')} count={allTabsBadgeCount} />
          }
          value={first}
          className={classes.tab}
        />
        <Tab
          label={
            <LabelWithBadge
              label={t('components.LoanOfficerRealEstateAgents.Tabs.waitlistTab')}
              count={waitlistTabsBadgeCount}
            />
          }
          value={second}
          className={classes.tab}
        />
        <Tab
          label={
            <LabelWithBadge
              label={t('components.LoanOfficerRealEstateAgents.Tabs.favoritesTab')}
              count={favoriteTabsBadgeCount}
            />
          }
          value={third}
          className={classes.tab}
        />
      </MuiTabs>
    </div>
  );
};

Tabs.propTypes = {
  currentTabIndex: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  tabIndexValues: PropTypes.arrayOf(PropTypes.number).isRequired,
  allTabsBadgeCount: PropTypes.number,
  waitlistTabsBadgeCount: PropTypes.number,
  favoriteTabsBadgeCount: PropTypes.number,
};

Tabs.defaultProps = {
  allTabsBadgeCount: null,
  waitlistTabsBadgeCount: null,
  favoriteTabsBadgeCount: null,
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/Tabs/Tabs.js